<template>

  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitPrepaymentRequestData">
      <div class="card-body">
        <div class="form-group row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-label">{{ $t('prepayments.offer_requested_on_date') }}</label><span
              class="text-danger"> *</span>
              <base-select
                v-model="formData.supplier_offer_request"
                :options=offer_request
                :allow-empty="false"
                :show-labels="false"
                :tabindex="5"
                :placeholder="$t('prepayments.select_offer_request')"
                label="name"
                track-by="label"
              />
              <div v-if="$v.formData.supplier_offer_request.$error">
                <span v-if="!$v.formData.supplier_offer_request.required" class="text-danger">{{ $t('validation.required') }}</span>
              </div>
            </div>
          </div>
          <div v-if="formData.supplier_offer_request && formData.supplier_offer_request.label==='select_a_date'"
               class="col-sm-6">
            <div class="form-group">
              <label class="form-label">{{ $t('prepayments.offer_requested_on_date') }}</label>
              <base-date-picker
                v-model="formData.supplier_offer_request_date"
                :calendar-button="true"
                calendar-button-icon="calendar"
                :disabledDates="{
                    to: new Date(Date.now())
                  }"
              />
            </div>
          </div>
        </div>
        <div class="card-footer">
          <base-button
            :outline="true"
            class="mr-3"
            color="theme"
            type="button"
            @click="closeBulkProcessModal"
          >
            {{ $t('general.cancel') }}
          </base-button>
          <base-button
            :loading="isLoading"
            icon="save"
            color="theme"
            type="submit"
            class="collapse-button"
          >
            {{ $t('prepayments.save_prepayment') }}
          </base-button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import MultiSelect from 'vue-multiselect'
  import {validationMixin} from 'vuelidate'
  import moment from 'moment'

  const {required, between, maxLength, numeric} = require('vuelidate/lib/validators')

  export default {
    components: {MultiSelect},
    mixins: [validationMixin],
    data() {
      return {
        offer_request: [
          {
            "id": 1,
            "name": " As Soon as Possible",
            "label": "as_soon_as_possible"
          },
          {
            "id": 2,
            "name": "Select a Date",
            "label": "select_a_date"
          }
        ],
        formData: {
          supplier_offer_request: null,
          supplier_offer_request_date: null,
          ids: {}
        },
        isLoading: false

      }
    },
    watch: {},
    validations() {
      return {
        formData: {
          supplier_offer_request: {
            required
          }
        }
      }
    },
    computed: {
      ...mapGetters('invoice', [
        'selectedInvoices'
      ]),
      ...mapGetters('modal', [
        'modalData',
      ]),
    },
    mounted() {
      this.formData.ids = this.selectedInvoices
      this.formData.supplier_offer_request_date = moment(new Date(Date.now() + 1 * 24 * 60 * 60 * 1000)).toString()
    },
    methods: {
      ...mapActions('modal', [
        'closeModal',
        'resetModalData',
        'setIsSearching'
      ]),

      ...mapActions('invoice', [
        'bulkProcessRequestedInvoicesWithData',
      ]),


      async submitPrepaymentRequestData() {
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
          return true
        }
        if (this.formData.supplier_offer_request && this.formData.supplier_offer_request.label === 'as_soon_as_possible') {
          this.formData.supplier_offer_request_date = null
        }
        let data = {
          ...this.formData,
          supplier_offer_request: this.formData.supplier_offer_request ? this.formData.supplier_offer_request.label : null,
          supplier_offer_request_date: this.formData.supplier_offer_request_date ? moment(this.formData.supplier_offer_request_date).format('DD/MM/YYYY') : null,
        }
        this.isLoading = true
        this.closeModal()

        swal({
              title: this.$t('general.are_you_sure'),
              text: this.$tc('invoices.supplier_requested_invoices'),
              icon: '/assets/icon/paper-plane-solid.svg',
              buttons: true,
              dangerMode: true
            }).then(async (value) => {
               if (value) {
                 this.setIsSearching()
                 let res = await this.bulkProcessRequestedInvoicesWithData(data)
                 this.setIsSearching()
                 if (res.data.success === true) {
                  location.reload();
                  this.filtersApplied = false
                  this.resetSelectedInvoices()
                  window.toastr['success'](this.$t('prepayments.prepayment_request_send_message'))
                } else if (res.data.success === false) {
                  window.toastr['error'](res.data.error)
                }
              }
            })
      },

      resetFormData () {
        this.formData = {
          supplier_offer_request: null,
          supplier_offer_request_date: null,
        }
        this.$v.formData.$reset()
      },
      closeBulkProcessModal () {
        this.resetModalData()
        this.resetFormData()
        this.closeModal()
      },
    }
  }
</script>
<style scoped>
  .table-component {
    min-height: 0px;
  }
</style>
